import axios from 'axios';
import React, { useEffect, useState } from 'react'
import "./App.css"
import Card from './Card'
import Header from './Header';
import Notfound from './Notfound';
import {Route , Routes} from 'react-router-dom'
import Contact from './Contact';
function App() {

 const [inputV, setInputV] = useState("");
 const [ori, setOri] = useState("horizontal");
 const [data, setData] = useState([]);
 const [isDarkMode, setIsDarkMode] = useState(true);
 const [theme, setTheme] = useState({
  background: "#fff",
  color: "black"
 })

 useEffect(()=> {
  document.title = "Lacks - About Me"
} , [])

useEffect( () => {
  
 let fetching =  setTimeout(() => {
    axios.get(`https://pixabay.com/api/?key=28944717-5241c7ed40926341f7c47ba6f&q=${inputV}&image_type=photo&orientation=${ori}`).then((res) => 
  {console.log(res.data.hits)
    setData(res.data.hits);
})
  }, 2000);

  return () => clearTimeout(fetching)

 
} , [inputV , ori])

// DARK MODE CODE 

const darkToggle = () => {
  if(isDarkMode === false) {
    setTheme({background: "#fff" , color: "black"})
    setIsDarkMode(true);
  }
  else {
    setTheme({background: "#121212" , color: "#fff"})
    setIsDarkMode(false);
  }
}

  return (
    <>
     <Routes>
          <Route path='/' element={ <Header toggle={darkToggle}/>} />
          <Route path='/contact' element={<Contact theme={theme} />} />
          {/* <Route path='/about' element={<About />} /> */}
        </Routes>
   
    <div className='cen' style={theme}>
    <input type="text" id='srch' placeholder='Search' value={inputV} onChange={(event) => {setInputV(event.target.value)}} className="form-control" style={theme}/>

<div className="btn-group">
  <button type="button" className="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
  Orientation
  </button>
  <ul className="dropdown-menu mx-3">

    <li className="dropdown-item" onClick={() => {setOri("horizontal")}}>Horizental</li>
    <li><hr className="dropdown-divider" /></li>
    <li className="dropdown-item" onClick={() => {setOri("vertical")}} >Vertical</li>
    
  </ul>
</div>
    </div>
   
      <div className='grid' style={theme}>
        {
           data.length ===0 ? <Notfound theme={theme}/> : data.map((dat) => {
            return <div  key={dat.id}>
              <Card img={dat.largeImageURL}
             likes={dat.likes}
             views={dat.views}
             author={dat.user}
             downloads={dat.downloads}
             tag1={dat.tags.split(' ')[0]}
             tag2={dat.tags.split(' ')[1]}
             tag3={dat.tags.split(' ')[2]}
             url={dat.pageURL}
             theme={theme}
             />
             </div>
          })
        }
        
      </div>
        {/* routes  */}
       

    </>
  )
}

export default App